import React from "react";
import { AvatarCard } from "common/AvatarCard";
import { getDisplayName } from "helpers/getDisplayName";
import { KeyContactIcon } from "common/customIcons/KeyContactIcon";

interface IEmployeeAvatarProps {
  employee: {
    info: {
      firstName: string | null;
      lastName: string | null;
      imageUrl: string | null;
    };
    email?: string;
    isKeyContact?: boolean;
  } | null;
  flexibleWidth?: boolean;
  small?: boolean;
}
export const EmployeeAvatar: React.FC<IEmployeeAvatarProps> = ({
  employee,
  flexibleWidth,
  small,
}) => {
  return (
    <AvatarCard
      primaryText={getDisplayName(
        employee?.info?.firstName,
        employee?.info?.lastName,
        employee?.email,
      )}
      secondaryText={employee?.email}
      imageUrl={employee?.info?.imageUrl || null}
      flexibleWidth={flexibleWidth}
      avatarIcon={
        employee?.isKeyContact ? (
          <KeyContactIcon color="warning" fontSize="small" />
        ) : undefined
      }
      small={small}
    />
  );
};
